// extracted by mini-css-extract-plugin
export default {"component":"Home_component__FCrSA"};